<template>
  <div class="d-flex">
    <div class="d-flex flex-wrap my-auto">
      <div class="ma-1" v-for="(origin, index) in origins" :key="index">
        <div class="d-flex">
          <div class="font-weight-bold text-no-wrap" style="width: min-content">
            {{ origin.description }}
          </div>
          <v-checkbox
            :input-value="isGroupChecked(origin.id)"
            dense
            @change="handleGroupCheckedClick(origin.id)"
            class="ma-0 pa-0"
            hide-details
          />
        </div>
      </div>
    </div>
    <div class="flex-grow-0 ml-2 my-auto">
      <v-btn
        class="text-none my-2"
        @click="clearAttributesObj"
        color="primary"
        text
      >
        <v-icon>{{ generateMessage('boilerplate.icons.refresh') }}</v-icon>
        <span class="text-decoration-underline">
          {{ generateMessage('boilerplate.filters.reset') }}
        </span>
      </v-btn>
      <custom-page-selector namespace="logbook" />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import CustomPageSelector from '@/components/selects/customPageSelector/index';
import Maths from '@/business/utils/maths';
import { generateMessage } from '@/utils/i18n';

const { mapGetters, mapActions } = createNamespacedHelpers('logbook');

export default {
  name: 'LogbookReducedFilters',
  components: {
    CustomPageSelector,
  },
  data() {
    return {
      isDisabled: false,
    };
  },
  computed: {
    ...mapGetters({
      origins: 'origins/items',
      attributesObj: 'attributesObj',
      isLoading: 'isLoadingAttributesObjRef',
      payloadTypesOrigin: 'payloadTypes/payloadTypesOrigin',
      payloadTypes: 'payloadTypes/items',
      itemsHasAttributeValueNumber: 'itemsHasAttributeValueNumber',
      isAttributesObjEqualToRef: 'isAttributesObjEqualToRef',
    }),
    currentProperty: {
      get() {
        return this.$store.getters['properties_360/current'];
      },
    },
    selected: {
      get() {
        return this.attributesObj.payload_type_id.values;
      },
      set(val) {
        this.setLogbookPayloadsFilter(val);
      },
    },
  },
  methods: {
    generateMessage,
    ...mapActions(['setFilterAttribute', 'clearAttributesObj']),
    subTypes(originId) {
      if (![3, 2].includes(originId)) return this.payloadTypesOrigin(originId); // exclude 'Demande d'intervention' et 'Hypervision Energétique'
      return null;
    },
    setLogbookPayloadsFilter(values) {
      this.setFilterAttribute({
        attribute: 'payload_type_id',
        values,
        useDelay: true,
      });
    },
    isGroupChecked(originId) {
      const idx = this.payloadTypesOrigin(originId).map((item) => item.id);
      return Maths.arrayContainsArray(this.selected, idx);
    },
    checkGroup(originId) {
      const idx = this.payloadTypesOrigin(originId).map((item) => item.id);
      this.setLogbookPayloadsFilter([...new Set(idx.concat(this.selected))]);
    },
    unCheckGroup(originId) {
      const idx = this.payloadTypesOrigin(originId).map((item) => item.id);
      this.setLogbookPayloadsFilter(
        Maths.arrayRemoveValues(this.selected, idx)
      );
    },
    handleGroupCheckedClick(originId) {
      if (this.isGroupChecked(originId)) {
        this.unCheckGroup(originId);
      } else {
        this.checkGroup(originId);
      }
    },
  },
};
</script>
